/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Code_Trees_Modified_ByInputs */

const en_tables_contact_code_trees_modified_by = /** @type {(inputs: Tables_Contact_Code_Trees_Modified_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By`)
};

const de_tables_contact_code_trees_modified_by = /** @type {(inputs: Tables_Contact_Code_Trees_Modified_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By`)
};

/**
* | output |
* | --- |
* | "By" |
*
* @param {Tables_Contact_Code_Trees_Modified_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_code_trees_modified_by = /** @type {((inputs?: Tables_Contact_Code_Trees_Modified_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Code_Trees_Modified_ByInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_code_trees_modified_by(inputs)
	return de_tables_contact_code_trees_modified_by(inputs)
});